import { render } from "./Cashier.vue?vue&type=template&id=3dc5f0ca&scoped=true"
import script from "./Cashier.vue?vue&type=script&lang=js"
export * from "./Cashier.vue?vue&type=script&lang=js"

import "./Cashier.vue?vue&type=style&index=0&id=3dc5f0ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc5f0ca"]])

export default __exports__